import { updateValue } from '../../library/siteCookie'

export default ($el) =>
  ({
    el: $el,
    success: false,
    watchSubmit(event) {
      this.el.classList.add('opacity-50')
    },
    handleError(event) {
      this.el.classList.remove('opacity-50')
    },
    freeformSuccess(event) {
      this.success = true
      updateValue('mailingList', 'reg') // update cookie
      setTimeout(() => {
        this.success = true
      }, 3000)
    },
  })
